import { ICellRendererParams } from 'ag-grid-community';

export interface BaseCellRendererParams extends Partial<ICellRendererParams> {
  renderCustomContent: (
    rootDiv: HTMLDivElement,
    rowNode: any,
    rowIndex: number
  ) => void;
}
class BaseCellRenderer {
  private eGui: any;

  init(params: BaseCellRendererParams) {
    this.eGui = document.createElement('div');
    if (!params.node.data) return;
    this.eGui.setAttribute('part', 'base-cell-renderer');

    if (params.renderCustomContent) {
      params.renderCustomContent(
        this.eGui,
        params.node.data,
        params.node.rowIndex
      );
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh() {
    return true;
  }
}

export { BaseCellRenderer };
